module.exports = __webpack_public_path__ + "img/3d1f16a.png";